import "../../assets/styles/components/textfield.scss";
interface Props {
  title: string;
  value: string;
  className?: string;
  align?: string;
}
const TextBox: React.FC<Props> = ({ title, value, className, align }) => {
  return (
    <div className={`text-box ${className}`}>
      <div className="title-text-box">{title}</div>
      <div className={`value-text-box ${align ? align : ""}`}>{value}</div>
    </div>
  );
};
export default TextBox;
